import axios from "axios";


const RuntimeEnvironment = () => {
    let url;
    //console.log('detecting runtime environment');

    if (window.location.origin === 'http://localhost:8081'){
        url = 'http://localhost:8080/tirefinder';
    } else if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production' ){
        url = window.location.origin + '/tirefinder';
    } else {
        url = '';
    }
    //console.log(url);
    return url ;
};

export default axios.create({
    baseURL: RuntimeEnvironment(),
    headers: {
        "Content-type": "application/json"
    },
});
